import { render, staticRenderFns } from "./member-income.vue?vue&type=template&id=d80111b8&scoped=true&"
import script from "./member-income.vue?vue&type=script&lang=js&"
export * from "./member-income.vue?vue&type=script&lang=js&"
import style0 from "./member-income.vue?vue&type=style&index=0&id=d80111b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80111b8",
  null
  
)

export default component.exports